import React, { FC } from 'react';
import s from './generatedCodesSection.module.scss';
import { useTranslation } from '@hooks/useTranslation';
import { toy } from '@prisma/client';
import { List } from '@components/Pages/ToysPages/GeneratedCodes/List/List';
import { InViewHookResponse } from 'react-intersection-observer';
interface Props {
  inView: InViewHookResponse['inView'];
  blockRef: InViewHookResponse['ref'];
  toyId: toy['id'];
  name: toy['name'];
  slug: toy['slug'];
}
export const GeneratedCodesSection: FC<Props> = ({
  toyId,
  name,
  slug,
  blockRef,
  inView
}) => {
  const {
    translate: tr
  } = useTranslation();
  return <div className={s.generatedCodesSection} ref={blockRef} data-sentry-component="GeneratedCodesSection" data-sentry-source-file="GeneratedCodesSection.tsx">
            <div className={s.generatedCodesSection__box}>
                <div className={s.generatedCodesSection__title}>
                    {tr({
          id: 'toy.page.generated.codes.title'
        })}
                </div>
                <List inView={inView} name={name} slug={slug} toyId={toyId} onlyOneFetch={true} data-sentry-element="List" data-sentry-source-file="GeneratedCodesSection.tsx" />
            </div>
        </div>;
};